import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Şifren güncellendi. Şimdi giriş yapabilirsin.");
      navigate("/giris");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Yeni şifre belirle" subtitle="Hesabın için yeni bir şifre oluştur.">
      {!token ? (
        <p className="text-ink-2">Geçersiz bağlantı. <Link to="/sifremi-unuttum" className="text-terra underline">Tekrar dene</Link></p>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">Yeni şifre</Label>
            <Input id="password" data-testid="reset-password" type="password" required minLength={6} value={password}
              onChange={(e) => setPassword(e.target.value)} className="mt-1 h-11" />
          </div>
          <Button type="submit" disabled={loading} data-testid="reset-submit"
            className="w-full h-11 bg-terra hover:bg-terra-hover text-white rounded-lg">
            {loading ? "Kaydediliyor..." : "Şifreyi Güncelle"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
